import { authFetch } from "../utils/authFetch"
import { API_BASE_URL } from "../config"

// URL base para la API de clientes
const baseUrl = `${API_BASE_URL}/cliente`

/**
 * Obtiene la lista de todos los clientes.
 */
const getSucursal = () => {
  return localStorage.getItem("idsucursal")
}

export const getClientes = async () => {
  const idSucu = getSucursal()
  const response = await authFetch(`${baseUrl}/sucursal/${idSucu}`, {
    method: "GET",
  })
  if (response.status === 204) return [];
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al consultar los clientes: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/**
 * Busca un cliente por su número de placa.
 * @param {string} placa - La placa del cliente a buscar.
 * @returns {Promise<object>} Una promesa que se resuelve con los datos del cliente encontrado.
 */
export const getClienteByPlaca = async (placa) => {
  const response = await authFetch(`${baseUrl}/buscar/${placa}`, {
    method: "GET",
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Cliente con placa ${placa} no encontrado: ${errorText || "Sin detalles"}`)
  }
  return response.json()
}

/**
 * Crea un nuevo cliente.
 */
export const createCliente = async (clienteData) => {
  const response = await authFetch(`${baseUrl}/crear`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(clienteData),
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al crear el cliente: ${errorText || "Sin detalles"}`)
  }
  const contentType = response.headers.get("Content-Type")
  if (contentType && contentType.includes("application/json")) {
    return response.json()
  }
  return { success: true }
}

/**
 * Actualiza un cliente existente.
 */
export const updateCliente = async (id, clienteData) => {
  const response = await authFetch(`${baseUrl}/modificar/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(clienteData),
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al actualizar el cliente: ${errorText || "Sin detalles"}`)
  }
  const contentType = response.headers.get("Content-Type")
  if (contentType && contentType.includes("application/json")) {
    return response.json()
  }
  return { success: true }
}

/**
 * Elimina un cliente.
 */
export const deleteCliente = async (id) => {
  const response = await authFetch(`${baseUrl}/eliminar/${id}`, {
    method: "DELETE",
  })
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Error al eliminar el cliente: ${errorText || "Sin detalles"}`)
  }
  return { success: true }
}

